<script>
import { mapActions } from "vuex";
import InfiniteAutocomplete from "./InfiniteAutocomplete.vue";

/**
 * 収運・処分事業者選択コンポーネント
 *
 */
export default {
  name: "InfiniteTraderAutoComplete",
  components: {
    InfiniteAutocomplete,
  },
  props: {
    traderId: {
      type: Number,
      default: null
    },
    label: {
      type: String,
      default: "収運・処分業者",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    rounded: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    classes: {
      type: String,
      default: null,
    },
    /**
     * カラム幅の指定
     */
    md: {
      type: [Number, String],
      default: 4,
    },
    /**
     * 展開する種別
     * transport: 運搬業者
     * trader: 処分業者
     * either: 運搬・処分両方
     */
    searchType: {
      type: String,
      default: "transport",
      validator(val) {
        return ["transport", "trader", "either"].includes(val);
      },
    },
    /**
     * 非表示を除く
     */
    withoutInvisible: {
      type: Boolean,
      default: false,
    },
    withoutNoneReporting: {
      type: Boolean,
      default: false,
    },
    withoutNoneSubscribe: {
      type: Boolean,
      default: false,
    },
    /**
     * 事業場未登録の事業者を含む
     */
    withNoneLocation: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      loading: false,
      searchKeyword: null,
      timerId: undefined,
      pageNumber: 0,
      traders: [],
      pagination: {
        next_page: null,
        prev_page: null,
        is_first_page: false,
        is_last_page: false,
      },
      workableId: null,
    };
  },
  computed: {},
  watch: {
    /**
     * 事業者IDの変更検知
     * @param newValue 事業者ID
     * @param oldValue
     */
    traderId(newValue, oldValue) {
      this.workableId = newValue;
      if (newValue !== oldValue) {
        this.loadTrader(this.workableId);
      }
    },
    /**
     * 作業用排出事業場IDの変更検知
     */
    workableId() {
      this.returnValues();
    },
  },
  /**
   * 画面ロード時に呼ばれる.
   * ここで初期設定などを行う.
   */
  created() {
    if (this.traderId) {
      this.workableId = this.traderId;
      this.loadTrader(this.workableId);
    } else {
      this.fetchTraderMembers();
    }
  },

  methods: {
    ...mapActions("DriverMasterSearchTraderMember", {
      fetchTraders: "index",
    }),
    /**
     * 事業者チェンジ コールバック
     * ・事業場の再取得を行う
     */
    changeCallback() {
    },
    /**
     * 事業者クリア コールバック
     */
    clearCallback() {
      this.workableId = null;
      this.reloadTraders();
    },
    loadTrader(id) {
      const conditions = {
        search_type: this.searchType,
        target_id: id,
        without_invisible: this.withoutInvisible,
        without_non_reporting: this.withoutNoneReporting,
        without_non_subscribe: this.withoutNoneSubscribe,
        with_none_location: this.withNoneLocation,
        page: 1,
      };

      this.fetchTraders({ params: conditions }).then((response) => {
        this.traders = response.traders;
        this.pagination = response.pagination;
        this.pageNumber = response.pagination.current_page;
      });
    },
    /**
     * 事業者 リロード処理
     */
    reloadTraders() {
      this.searchKeyword = null;
      this.pageNumber = 0;
      this.traders = [];
      Object.assign( this.$data.pagination, this.$options.data().pagination );
      this.fetchTraderMembers();
    },
    /**
     * 排出事業者オプション取得アクション
     * @returns {Promise<unknown>}
     */
    fetchTraderMembers() {
      this.loading = true;
      const conditions = {
        query: this.searchKeyword,
        without_invisible: this.withoutInvisible,
        without_non_reporting: this.withoutNoneReporting,
        without_non_subscribe: this.withoutNoneSubscribe,
        with_none_location: this.withNoneLocation,
        search_type: this.searchType,
        page: this.pageNumber,
      };

      this.fetchTraders({ params: conditions }).then((response) => {
        this.traders = this.traders.concat(response.traders);
        this.pagination = response.pagination;
        this.pageNumber = response.pagination.current_page;
      })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * 排出事業者
     * 次ページ読込
     */
    insectCallback() {
      if (this.pageNumber > 0) {
        this.pageNumber++;
        this.fetchTraderMembers();
      }
    },
    enterKeydownCallback (value) {
      this.pageNumber = 0;
      this.searchKeyword = value;
      this.fetchTraderMembers();
    },
    returnValues() {
      this.$emit("update:values", this.workableId);
    },
  },
};
</script>
<template>
  <div>
    <validation-provider
      v-slot="{ errors }"
      :value="workableId"
      :rules="{ required: required }"
      :class="{ requiredMark: required }"
      :name="label"
    >
      <infinite-autocomplete
        v-model="workableId"
        :classes="classes"
        :disabled="disabled"
        :error-messages="errors"
        :label="label"
        :loading="loading"
        :members="traders"
        :pagination="pagination"
        :rounded="rounded"
        item-text="label"
        @change="changeCallback"
        @click:clear="clearCallback"
        @insect="insectCallback"
        @keydown:enter="enterKeydownCallback"
      >
        <template v-slot:prepend>
          <slot name="prepend" />
        </template>
        <template v-slot:prepend-inner>
          <slot name="prepend-inner" />
        </template>
        <template v-slot:selection="{ item }">
          <slot name="selection" v-bind:item="item">
            {{ item.text }}
          </slot>
        </template>
        <template v-slot:item="{ item }">
          <slot name="item" v-bind:item="item">
            {{ item.label }}
          </slot>
        </template>
        <template v-slot:append>
          <slot name="append" />
        </template>
        <template v-slot:append-outer>
          <slot name="append-outer" />
        </template>
      </infinite-autocomplete>
    </validation-provider>
  </div>
</template>
